import Screenfull from './Screenfull';
import SVGReplace from './SvgReplace';

import './Utils.scss';

export {
    Screenfull,
    SVGReplace
};
